export default __webpack_public_path__ + "1673db714c94fd11279e0e5ae99d14a7.svg";